import {
	MessageBox
} from 'element-ui';
import {
	Loading
} from 'element-ui';
import Vue from 'vue';
import Pagination from "@/components/Pagination";
import service from '@/utils/request'
const headerCellStyle = {
	background: '#f7f9fa',
	color: '#606266'
}
const baseURL = process.env.VUE_APP_BASE_API

// 通用下载方法 encodeURI() 函数可把字符串作为 URI 进行编码,不会进行转义
const download = function(fileName) {
	window.location.href = baseURL + "/common/download?fileName=" + encodeURI(fileName) + "&delete=" + true;
}

const download1 = function(fileName) {
	window.location.href = baseURL + "/profile/" + fileName;
}
// 通用上传方法
const upload = function() {
	return baseURL + "/app/common/upload";
}
// 富文本上传方法 返回全路径
const upload1 = function() {
	return baseURL + "/app/common/upload1";
}
// 通用删除文件方法 path:放数据库存的路径就行
const delFile = function(param) {
	return service.request({
		method: 'post',
		url: '/app/common/delFile',
		data: param
	})
}
//随机颜色
const randomRgb = function() {
	let R = Math.floor(Math.random() * 255);
	let G = Math.floor(Math.random() * 255);
	let B = Math.floor(Math.random() * 255);
	return 'rgb(' + R + ',' + G + ',' + B + ')'
}
//动态计算表格高度
const tableHeight = function() {
	//  动态计算表格高度
	let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
	// 此处减去200即为当前屏幕内除了表格高度以外其它内容的总高度，
	return windowHeight - 200;
}

// 校验角色
const checkRole = function(role) { 
	let roleStr = this.$store.getters['user/curRoleFlag']; 
	return roleStr[role]?true:false
}

export default {
	install(Vue, options) {
		Vue.component('Pagination', Pagination); //分页组件
		Vue.prototype.confirm = function(param) {
			MessageBox.confirm(param.text, param.tip || '提示', {
				confirmButtonText: param.but1 || '确定',
				cancelButtonText: param.but2 || '取消',
				type: param.type || 'warning',
				distinguishCancelAndClose: true,
				center: true
			}).then(() => {
				if (param.fn) { //判断是否有确认函数 执行回调函数
					param.fn(param.data);
				}
			}).catch(action => {
				//判断是取消按钮还是 右上角x图标
				if (action === 'cancel') {
					if (param.cancel) { //判断是否有取消函数 执行回调函数
						param.cancel(param.data);
					}
				}

			});
			console.log("自定义全局组件"); //  相当于挂载 页面 this.confirm()调用
		}

		Vue.prototype.Loading = function(param) {

			return Loading.service({
				fullscreen: true,
				text: param.text || '执行中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'

			});

		}

		//全局表头样式
		Vue.prototype.headerCellStyle = headerCellStyle
		// 通用下载方法
		Vue.prototype.download = download
		// 下载
		Vue.prototype.download1 = download1
		// 通用上传方法
		Vue.prototype.upload = upload
		// 通用删除文件方法
		Vue.prototype.upload1 = upload1
		// 通用删除文件方法
		Vue.prototype.delFile = delFile

		Vue.prototype.baseURL = baseURL

		Vue.prototype.randomRgb = randomRgb
		// 表格高度
		Vue.prototype.tableHeight = tableHeight

		Vue.prototype.checkRole = checkRole

		Vue.prototype.token = function() {
			return window.localStorage.getItem("token");
		}
		//其他挂机
		Vue.prototype.xxxx = () => {

		}
	}
}
